export default {
  // ALL PAGES
  DZ_BLOG_PAGE_TIME_SPENT: 'DZ_BLOG_PAGE_TIME_SPENT', // With timer value
  DZ_RF_PAGE_TIME_SPENT: 'DZ_RF_PAGE_TIME_SPENT', // With timer value
  DZ_MM_PAGE_TIME_SPENT: 'DZ_MM_PAGE_TIME_SPENT', // With timer value
  // HOME PAGE
  DZ_HOME_LAND: 'DZ_HOME_LAND',
  DZ_HOME_RF_ITEM_TAP: 'DZ_HOME_RF_ITEM_TAP', // WITH ID PARAM
  DZ_HOME_MM_ITEM_TAP: 'DZ_HOME_MM_ITEM_TAP', // WITH ID PARAM
  DZ_HOME_BLOG_ITEM_TAP: 'DZ_HOME_BLOG_ITEM_TAP', // blog id
  DZ_HOME_BLOG_ITEMS_SWIPE: 'DZ_HOME_BLOG_ITEMS_SWIPE',
  DZ_HOME_SIGNUP_CTA_TAP: 'DZ_HOME_SIGNUP_CTA_TAP',
  DZ_RF_TAKE_QUIZ_CTA_TAP: 'DZ_RF_TAKE_QUIZ_CTA_TAP',
  DZ_MM_TAKE_QUIZ_CTA_TAP: 'DZ_MM_TAKE_QUIZ_CTA_TAP',
  HOME_SCREEN_FEATURED_LESSON_CTA_TAP: 'HOME_SCREEN_FEATURED_LESSON_CTA_TAP',
  DZ_HOME_RR_BTN_TAP: 'DZ_HOME_RR_BTN_TAP',
  // RF PAGE
  DZ_RF_LAND: 'DZ_RF_LAND', // WITH ACTIVITY TYPE OR ID
  DZ_RF_NEXT_CTA_TAP: 'DZ_RF_NEXT_CTA_TAP',
  DZ_RF_VIDEO_START: 'DZ_RF_VIDEO_START',
  DZ_RF_VIDEO_END: 'DZ_RF_VIDEO_END',
  DZ_RF_BACK_BTN_TAP: 'DZ_RF_BACK_BTN_TAP',
  DZ_RF_GET_CERTIFIED_BTN_TAP: 'DZ_RF_GET_CERTIFIED_BTN_TAP',
  // MM PAGE
  DZ_MM_LAND: 'DZ_MM_LAND',
  DZ_MM_GET_CERTIFIED_BTN_TAP: 'DZ_MM_GET_CERTIFIED_BTN_TAP',
  // QUIZ
  DZ_RF_QUIZ_LAND: 'DZ_RF_QUIZ_LAND',
  DZ_MM_QUIZ_LAND: 'DZ_MM_QUIZ_LAND',
  DZ_RF_QUIZ_SELECT_OPTION: 'DZ_RF_QUIZ_SELECT_OPTION',
  DZ_MM_QUIZ_SELECT_OPTION: 'DZ_MM_QUIZ_SELECT_OPTION',
  DZ_RF_QUIZ_BACK_TAP: 'DZ_RF_QUIZ_BACK_TAP',
  DZ_MM_QUIZ_BACK_TAP: 'DZ_MM_QUIZ_BACK_TAP',
  // QUIZ FEEDBACK
  DZ_RF_QUIZ_FEEDBACK_LAND: 'DZ_RF_QUIZ_FEEDBACK_LAND',
  DZ_MM_QUIZ_FEEDBACK_LAND: 'DZ_MM_QUIZ_FEEDBACK_LAND',
  DZ_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP: 'DZ_QUIZ_FEEDBACK_VIEW_INCORRECT_ANSWERS_TAP',
  DZ_QUIZ_FEEDBACK_QUIT_BTN_TAP: 'DZ_QUIZ_FEEDBACK_QUIT_BTN_TAP',
  DZ_QUIZ_FEEDBACK_DOIT_LATER_BTN_TAP: 'DZ_QUIZ_FEEDBACK_DOIT_LATER_BTN_TAP',
  // QUIZ RESULTS
  DZ_RF_QUIZ_RESULTS_LAND: 'DZ_RF_QUIZ_RESULTS_LAND',
  DZ_MM_QUIZ_RESULTS_LAND: 'DZ_MM_QUIZ_RESULTS_LAND',
  DZ_QUIZ_RESULTS_VIEW_ALL_TAP: 'DZ_QUIZ_RESULTS_VIEW_ALL_TAP',
  DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP: 'DZ_RF_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP',
  DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP: 'DZ_MM_QUIZ_RESULTS_TAKE_TEST_AGAIN_TAP',
  // RC KIDS DOWNLOADS
  KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_3_to_5: 'KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_3_to_5',
  KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_6_to_8: 'KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_6_to_8',
  KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_9_to_12: 'KIDS_KIT_PDF_DOWNLOAD__MARCH_2022_AGE_9_to_12',
  // HOME
  HOME_SCREEN_WWTK_DONE: 'HOME_SCREEN_WWTK_DONE',
  HOME_SCREEN_WWTK_QUIZ_OPTION_SELECT: 'HOME_SCREEN_WWTK_QUIZ_OPTION_SELECT',
  HOME_SCREEN_WWTK_POLL_OPTION_SELECT: 'HOME_SCREEN_WWTK_POLL_OPTION_SELECT',
  HOME_SCREEN_BLOG_ITEM_TAP: 'HOME_SCREEN_BLOG_ITEM_TAP',
  BLOG_DETAILS_TIME_SPENT: 'BLOG_DETAILS_TIME_SPENT',

  // SPOTLIGHT MATERIALS
  HOME_SCREEN_MATERIAL_SPOTLIGHT_CTA_TAP: 'HOME_SCREEN_MATERIAL_SPOTLIGHT_CTA_TAP',
  MATERIAL_SPOTLIGHT_SCREEN_ITEM_VIEWED: 'MATERIAL_SPOTLIGHT_SCREEN_ITEM_VIEWED',
  HOME_SCREEN_MATERIAL_SPOTLIGHT_NEXT_BTN_TAP: 'HOME_SCREEN_MATERIAL_SPOTLIGHT_NEXT_BTN_TAP',
  HOME_SCREEN_MATERIAL_SPOTLIGHT_BACK_BTN_TAP: 'HOME_SCREEN_MATERIAL_SPOTLIGHT_BACK_BTN_TAP',

  // MISUNDERSTOOD MATERIALS
  HOME_SCREEN_MISUNDERSTOOD_MATERIAL_CTA_TAP: 'HOME_SCREEN_MISUNDERSTOOD_MATERIAL_CTA_TAP',
  HOME_SCREEN_MISUNDERSTOOD_MATERIAL_BACK_BTN_TAP: 'HOME_SCREEN_MISUNDERSTOOD_MATERIAL_BACK_BTN_TAP',
  HOME_SCREEN_MISUNDERSTOOD_MATERIAL_NEXT_BTN_TAP: 'HOME_SCREEN_MISUNDERSTOOD_MATERIAL_NEXT_BTN_TAP',
  MATERIAL_MISUNDERSTOOD_SCREEN_ITEM_VIEWED: 'MATERIAL_MISUNDERSTOOD_SCREEN_ITEM_VIEWED',
  // BLOGS
  BLOG_DETAILS_LAND: 'BLOG_DETAILS_LAND',
  // Recycle RIGHT
  DZ_RR_CLOSE_TAP: 'DZ_RR_CLOSE_TAP',
  DZ_RR_ANSWER: 'DZ_RR_ANSWER',
  DZ_RR_TIMEOUT: 'DZ_RR_TIMEOUT',
  DZ_RR_TIMEOUT_RESTART_LEVEL_BTN_TAP: 'DZ_RR_TIMEOUT_RESTART_LEVEL_BTN_TAP',
  DZ_RR_TIMEOUT_CONTINUE: 'DZ_RR_TIMEOUT_CONTINUE',
  DZ_RR_LEVEL_FAIL: 'DZ_RR_LEVEL_FAIL',
  DZ_RR_LEVEL_SUCCESS: 'DZ_RR_LEVEL_SUCCESS',
  DZ_RR_LEVEL_SUMMARY_SHOW_MORE_TAP: 'DZ_RR_LEVEL_SUMMARY_SHOW_MORE_TAP',
  DZ_RR_LEVEL_SUMMARY_RESTART_BTN_TAP: 'DZ_RR_LEVEL_SUMMARY_RESTART_BTN_TAP',
  DZ_RR_LEVEL_SUMMARY_NEXT_BTN_TAP: 'DZ_RR_LEVEL_SUMMARY_NEXT_BTN_TAP',
  DZ_RR_FINISHED_PLAY_AGAIN_BTN_TAP: 'DZ_RR_FINISHED_PLAY_AGAIN_BTN_TAP',
  // NEWS
  NEWS_LIST_LOAD: 'NEWS_LIST_LOAD',
  NEWS_ITEM_LOAD: 'NEWS_ITEM_LOAD',
  // LEARNING MODULES
  DZ_HOME_LM_ITEM_TAP: 'DZ_HOME_LM_ITEM_TAP',
  DZ_LM_BACK_BTN_TAP: 'DZ_LM_BACK_BTN_TAP',
  DZ_LM_VIDEO_START: 'DZ_LM_VIDEO_START',
  DZ_LM_VIDEO_END: 'DZ_LM_VIDEO_END',
  DZ_LM_LAND: 'DZ_LM_LAND',
  DZ_LM_PAGE_TIME_SPENT: 'DZ_LM_PAGE_TIME_SPENT'
};
